import React from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
// import "./WinnersLand.css";

import { useTheme, useCountUp } from "../WinnerLand/useTheme";

export function WinnersCitiesBlue({
  eyebrow,
  title,
  description,
  cities = [],
}) {
  return (
    <section className="ws-cities_blue">
      <div className="ws-cities-head_blue">
        <div>
          <span className="ws-section-eyebrow_blue">{eyebrow}</span>
          <h2 className="ws-section-heading_blue">{title}</h2>
        </div>
        <p>{description}</p>
      </div>

      <div className="ws-cities-grid_blue">
        {cities.map((c, i) => (
          <article className="ws-city-card_blue" key={c.name + i}>
            <div className="ws-city-img_blue">
              <img src={c.img} alt={c.name} loading="lazy" width={640} height={840} />
            </div>
            <span className="ws-city-badge_blue"><MapPin size={12} /> {c.tag}</span>
            <div className="ws-city-body_blue">
              <h3>{c.name}</h3>
              <div className="ws-city-meta_blue">
                <div><span className="ws-city-meta-num_blue">{c.count}</span> properties</div>
                <div className="ws-city-arrow_blue"><ArrowUpRight size={16} /></div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}